import { CommApiInstance } from "Utils/CommApiInstance";

const CommuBrdRegApi = async (
    brdCd:string,
    subCtgrCd:string|null,
    brdPstdTitl:string,
    brdPstdCtxt:string,
    thmbUrl:string|null,
    rqstTrxId:string|null,
    cptchTkn:string
) => {
    return await CommApiInstance.post(`brd/BBO/${brdCd}/reg`,{
        apiBody:{
            brdPstdTitl:brdPstdTitl,
            brdPstdCtxt:brdPstdCtxt,
            brdCtgrCd:subCtgrCd,
            thmbUrl:thmbUrl,
            rqstTrxId:rqstTrxId,
            cptchTkn:cptchTkn,
        }
    })
    .then((Resp) => Resp.data);
}
export default CommuBrdRegApi;